(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dimmer/assets/javascripts/dimmer.js') >= 0) return;  svs.modules.push('/components/components/dimmer/assets/javascripts/dimmer.js'); 

'use strict';

var CLASS_OPENED = 'dimmer-show';

function Dimmer(dimmerClickCallback, options) {
  var disableInput = options && options.disableInput ? options.disableInput : false;
  this.el = getAsNode(svs.components.dimmer.templates.dimmer());

  if (options && options.zIndexValue) {
    this.el.style.zIndex = options.zIndexValue;
  }

  this._isRendered = false;

  this._clickEventCallback = dimmerClickCallback || function () {};

  if (!disableInput) {
    this._eventListener = this._eventListener.bind(this);
    this.el.addEventListener('click', this._eventListener, false);
    this.el.addEventListener('touchstart', this._eventListener, false);
  }
}


Dimmer.prototype.render = function () {
  if (!this._isRendered) {
    document.body.insertBefore(this.el, document.body.childNodes[0]);
    this._isRendered = true;
  }

  return this;
};


Dimmer.prototype.show = function () {
  var _this = this;

  this.el.style.display = 'block';
  window.requestAnimationFrame(function () {
    _this.el.classList.add(CLASS_OPENED);
  });
  return this;
};


Dimmer.prototype.hide = function () {
  var _this2 = this;

  var transitionEnd = function transitionEnd() {
    _this2.el.style.display = 'none';

    _this2.el.removeEventListener('transitionend', transitionEnd, false);
  };

  if (svs.core.detect.os.windows()) {
    transitionEnd();
  } else {
    this.el.addEventListener('transitionend', transitionEnd, false);
  }

  this.el.classList.remove(CLASS_OPENED);
  return this;
};


Dimmer.prototype.destroy = function () {
  this.el.removeEventListener('click', this._eventListener, false);
  this.el.removeEventListener('touchstart', this._eventListener, false);

  if (this.el.parentNode) {
    this.el.parentNode.removeChild(this.el);
  } else {
    this.el.innerHTML = '';
  }

  this._isRendered = false;
  return this;
};


Dimmer.prototype._eventListener = function (event) {
  event.stopPropagation();
  event.preventDefault();
  this.hide();

  this._clickEventCallback();
};


function getAsNode(html) {
  var dom = document.createElement('div');
  dom.innerHTML = html;
  return dom.firstChild;
}

svs.components = svs.components || {};
svs.components.Dimmer = Dimmer;
 })(window);